import React from 'react';
const CarMarket = () => <div style={{padding:32}}>Зарын зах зээл (stub)</div>;
export default CarMarket;
